import ReducedLessonCard from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedLessonCard';
import ReducedTrackCard from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedTrackCard';
import LessonCardContainer from '../../../components/LessonCard/LessonCardContainer';
import ContentCardSkeleton from '../../../components/TrackCard/ContentCardSkeleton';
import TrackCardContainer from '../../../containers/TracksPage/TrackCardContainer';
import { ReducedShortCard, ShortCard } from '../../cards';
import { PlaylistCard, ReducedPlaylistCard } from '../../savedItems';
import { jsx as _jsx } from "react/jsx-runtime";
export const FullLearningContentItemCard = ({
  item,
  appearsIn,
  onItemClick,
  use,
  showDescription,
  showOverview
}) => {
  const {
    id,
    type,
    language
  } = item;
  const commonProps = {
    loadingState: /*#__PURE__*/_jsx(ContentCardSkeleton, {
      use: use
    }),
    appearsIn,
    use,
    showDescription,
    preferPreviewModal: showOverview
  };
  const handleClick = () => {
    if (onItemClick) onItemClick(item);
  };
  switch (type) {
    case 'TRACK':
      return /*#__PURE__*/_jsx(TrackCardContainer, Object.assign({
        "data-test-id": `track-${id}`,
        language: language,
        onClick: handleClick,
        trackId: id
      }, commonProps));
    case 'LESSON':
      return /*#__PURE__*/_jsx(LessonCardContainer, Object.assign({
        "data-test-id": `lesson-${id}`,
        language: language,
        lessonId: id,
        onClick: handleClick
      }, commonProps));
    case 'PLAYLIST':
      return /*#__PURE__*/_jsx(PlaylistCard, Object.assign({
        "data-test-id": `playlist-${id}`,
        onClick: handleClick,
        playlistId: id
      }, commonProps));
    case 'SHORT_FORM_CONTENT':
      return language ? /*#__PURE__*/_jsx(ShortCard, Object.assign({
        "data-test-id": `playlist-${id}`,
        language: language,
        onClick: handleClick,
        shortId: id
      }, commonProps)) : null;
    default:
      return null;
  }
};
export const ReducedLearningContentItemCard = ({
  item,
  appearsIn,
  onItemClick,
  use,
  size = 'small'
}) => {
  const {
    id,
    type,
    language
  } = item;
  const commonProps = {
    appearsIn,
    use,
    size
  };
  const handleClick = () => {
    if (onItemClick) onItemClick(item);
  };
  switch (type) {
    case 'TRACK':
      return /*#__PURE__*/_jsx(ReducedTrackCard, Object.assign({
        "data-test-id": `track-${id}`,
        language: language,
        onClick: handleClick,
        trackId: id
      }, commonProps));
    case 'LESSON':
      return /*#__PURE__*/_jsx(ReducedLessonCard, Object.assign({
        "data-test-id": `lesson-${id}`,
        language: language,
        lessonId: id,
        onClick: handleClick
      }, commonProps));
    case 'PLAYLIST':
      return /*#__PURE__*/_jsx(ReducedPlaylistCard, Object.assign({
        "data-test-id": `playlist-${id}`,
        onClick: handleClick,
        playlistId: id
      }, commonProps));
    case 'SHORT_FORM_CONTENT':
      return language ? /*#__PURE__*/_jsx(ReducedShortCard, Object.assign({
        "data-test-id": `playlist-${id}`,
        language: language,
        onClick: handleClick,
        shortId: id
      }, commonProps)) : null;
    default:
      return null;
  }
};
export const LearningContentItemCard = props => props.size === 'large' ? /*#__PURE__*/_jsx(FullLearningContentItemCard, Object.assign({}, props)) : /*#__PURE__*/_jsx(ReducedLearningContentItemCard, Object.assign({}, props));
export default LearningContentItemCard;